var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "period-selector" }, [
    _c("div", { staticClass: "row align-items-center" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-8" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-wrap gap-2 justify-content-center justify-content-lg-end",
          },
          _vm._l(_vm.periods, function (period) {
            return _c(
              "button",
              {
                key: period.value,
                staticClass: "btn btn-sm",
                class: _vm.getButtonClass(period.value),
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.selectPeriod(period.value)
                  },
                },
              },
              [
                period.value === "personalizado"
                  ? _c("i", { staticClass: "fal fa-calendar-plus me-1" })
                  : _vm._e(),
                _vm._v("\n          " + _vm._s(period.label) + "\n        "),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.showCustomSelector || _vm.selectedPeriod === "personalizado"
      ? _c("div", { staticClass: "custom-period-selector mt-3" }, [
          _c("div", { staticClass: "row g-3" }, [
            _c("div", { staticClass: "col-12 col-sm-6" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.customStartDate,
                    expression: "customStartDate",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "date",
                  id: "startDate",
                  max: _vm.customEndDate || _vm.maxDate,
                },
                domProps: { value: _vm.customStartDate },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.customStartDate = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-sm-6" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.customEndDate,
                    expression: "customEndDate",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "date",
                  id: "endDate",
                  min: _vm.customStartDate,
                  max: _vm.maxDate,
                },
                domProps: { value: _vm.customEndDate },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.customEndDate = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-4" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-wrap gap-2 justify-content-center justify-content-sm-end",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success btn-sm",
                      attrs: {
                        type: "button",
                        disabled: !_vm.customStartDate || !_vm.customEndDate,
                      },
                      on: { click: _vm.applyCustomPeriod },
                    },
                    [
                      _c("i", { staticClass: "fal fa-check me-2" }),
                      _vm._v(" Aplicar\n          "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary btn-sm",
                      attrs: { type: "button" },
                      on: { click: _vm.cancelCustomPeriod },
                    },
                    [
                      _c("i", { staticClass: "fal fa-times me-2" }),
                      _vm._v(" Cancelar\n          "),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-2" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("small", { staticClass: "text-muted" }, [
                _c("i", { staticClass: "fal fa-info-circle" }),
                _vm._v(" "),
                _vm.selectedPeriod === "personalizado" &&
                _vm.customStartDate &&
                _vm.customEndDate
                  ? _c("span", [
                      _vm._v(
                        "\n            Período personalizado aplicado: " +
                          _vm._s(_vm.formatDate(_vm.customStartDate)) +
                          " - " +
                          _vm._s(_vm.formatDate(_vm.customEndDate)) +
                          "\n          "
                      ),
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n            Selecciona un rango de fechas personalizado para analizar los datos\n          "
                      ),
                    ]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 col-lg-4 mb-3 mb-lg-0" }, [
      _c("h5", { staticClass: "mb-0" }, [
        _c("i", { staticClass: "fal fa-calendar-alt" }),
        _vm._v(" Período de Análisis"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "form-label mb-2", attrs: { for: "startDate" } },
      [
        _c("i", { staticClass: "fal fa-calendar-day text-warning me-2" }),
        _vm._v(" Fecha de Inicio\n        "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "form-label mb-2", attrs: { for: "endDate" } },
      [
        _c("i", { staticClass: "fal fa-calendar-day text-warning me-2" }),
        _vm._v(" Fecha de Fin\n        "),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }